module.exports = __webpack_public_path__ + "media/images/shapes/shape-2-9b381af1c7a8dc602d755e5aeb7d94cd.svg";